import { render, staticRenderFns } from "./Zgh.vue?vue&type=template&id=53c4ab9e&scoped=true"
import script from "./Zgh.vue?vue&type=script&lang=js"
export * from "./Zgh.vue?vue&type=script&lang=js"
import style0 from "./Zgh.vue?vue&type=style&index=0&id=53c4ab9e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c4ab9e",
  null
  
)

export default component.exports